import Raven from 'raven-js';
import { RECURRING_BILLING_FREQUENCIES } from '../constants/RecurringBillingFrequencies';
export function getLineItemRecurringFrequency(recurringBillingTerms) {
  if (!recurringBillingTerms) {
    return null;
  }
  const {
    intervalLength,
    intervalUnit
  } = recurringBillingTerms;
  if (intervalLength === 1 && intervalUnit === 'DAYS') {
    return RECURRING_BILLING_FREQUENCIES.DAYS;
  } else if (intervalLength === 1 && intervalUnit === 'WEEKS') {
    return RECURRING_BILLING_FREQUENCIES.WEEKS;
  } else if (intervalLength === 2 && intervalUnit === 'WEEKS') {
    return RECURRING_BILLING_FREQUENCIES.TWO_WEEKS;
  } else if (intervalLength === 1 && intervalUnit === 'MONTHS') {
    return RECURRING_BILLING_FREQUENCIES.MONTHS;
  } else if (intervalLength === 3 && intervalUnit === 'MONTHS') {
    return RECURRING_BILLING_FREQUENCIES.QUARTERS;
  } else if (intervalLength === 6 && intervalUnit === 'MONTHS') {
    return RECURRING_BILLING_FREQUENCIES.SIX_MONTHS;
  } else if (intervalLength === 1 && intervalUnit === 'YEARS') {
    return RECURRING_BILLING_FREQUENCIES.YEARS;
  } else {
    const error = new Error('Unsupported recurring billing configuration');
    Raven.captureException(error);
    throw error;
  }
}
export function getLineItemRecurringFrequencyBySubtotal(intervalUnit, intervalLength) {
  if (intervalLength === 1 && intervalUnit === 'DAYS') {
    return RECURRING_BILLING_FREQUENCIES.DAYS;
  }
  if (intervalLength === 1 && intervalUnit === 'WEEKS') {
    return RECURRING_BILLING_FREQUENCIES.WEEKS;
  }
  if (intervalLength === 2 && intervalUnit === 'WEEKS') {
    return RECURRING_BILLING_FREQUENCIES.TWO_WEEKS;
  }
  if (intervalLength === 1 && intervalUnit === 'MONTHS') {
    return RECURRING_BILLING_FREQUENCIES.MONTHS;
  }
  if (intervalLength === 3 && intervalUnit === 'MONTHS') {
    return RECURRING_BILLING_FREQUENCIES.QUARTERS;
  }
  if (intervalLength === 6 && intervalUnit === 'MONTHS') {
    return RECURRING_BILLING_FREQUENCIES.SIX_MONTHS;
  }
  if (intervalLength === 1 && intervalUnit === 'YEARS') {
    return RECURRING_BILLING_FREQUENCIES.YEARS;
  }
  if (intervalLength === 2 && intervalUnit === 'YEARS') {
    return RECURRING_BILLING_FREQUENCIES.TWO_YEARS;
  }
  if (intervalLength === 3 && intervalUnit === 'YEARS') {
    return RECURRING_BILLING_FREQUENCIES.THREE_YEARS;
  }
  const error = new Error('Unsupported recurring billing configuration');
  Raven.captureException(error);
  throw error;
}